import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./CategoryLevelOneTable.module.scss";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";

const CategoryLevelOneTable = ({ btnHandler, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const columns = [
    {
      title: "عکس",
      dataIndex: "photo",
      key: "photo",
      width: "25%",
      render: (text, record) => (
        <div className={Style.picHolder}>
          <img
            src={`http://cdn.barest.ir/category/${
              record.key
            }.jpg?${randomNumberInRange(1, 1000000000000)}`}
            alt=""
          />
        </div>
      ),
    },
    {
      title: "نام دسته بندی فارسی",
      dataIndex: "namePersian",
      key: "namePersian",
      width: "25%",
      ...getColumnSearchProps("namePersian", "نام دسته بندی فارسی"),
    },
    {
      title: "نام دسته بندی انگلیسی",
      dataIndex: "nameEnglish",
      key: "nameEnglish",
      width: "25%",
      ...getColumnSearchProps("nameEnglish", "نام دسته بندی انگلیسی"),
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "10%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => btnHandler(1, record)}
            className={Style.deleteBtn}
          >
            <TrashFill />
          </button>
          <button onClick={() => btnHandler(2, record)} className={Style.ok}>
            <PencilSquare />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 7 }}
        columns={columns}
        size={"small"}
        dataSource={data && data}
        responsive={true}
        scroll={{x:1500, y: 300 }}
      />
    </div>
  );
};

export default CategoryLevelOneTable;
